import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function Problems() {
  const problems = ['Te sentís perdido en el laboratorio porque nadie te explicó cómo funcionan realmente las cosas', 'Cometés errores que te cuestan tiempo y plata porque no conocés los trucos que usan los técnicos con experiencia', 'No sabés por dónde empezar con el flujo digital y CAD/CAM, y sentís que te estás quedando atrás', 'Querés independizarte y montar tu propio laboratorio pero no tenés idea de qué equipamiento necesitás ni cómo conseguir clientes', 'Te falta confianza para entregar trabajos de calidad profesional porque no dominás los materiales y técnicas modernas'];
  return <section className="w-full px-4 py-12 bg-white" data-id="element-108">
      <div className="max-w-3xl mx-auto" data-id="element-109">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8" data-id="element-110">
          Seguramente te paso alguna de estas cosas 😬
        </h2>

        <div className="space-y-2.5" data-id="element-111">
          {problems.map((problem, index) => <div key={index} className="flex items-start gap-3 px-4 py-3 bg-red-50 border border-red-200 rounded-xl shadow-sm" data-id="element-112">
              <XCircleIcon className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-113" />
              <p className="text-sm md:text-base text-red-700 leading-snug" data-id="element-114">
                {problem}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}